import { FC } from "react";

import {
  AccountHistoryCard,
  AccountHistoryCardBasePropsI,
} from "shared/ui/activity-log/cards-v2/base";
import { HistoryCardCallNotes } from "shared/ui/activity-log/cards-v2/base/notes";
import { HistoryCardActivityType } from "shared/ui/activity-log/cards-v2/base/activity-type";
import { HistoryCardContactInfo } from "shared/ui/activity-log/cards-v2/base/contact-info";
import { XMarkIcon } from "@heroicons/react/24/solid";

const ACTIVITY_TYPE_CONFIG = {
  icon: XMarkIcon,
  title: "Email Rejected For Invalid Email Address",
};

const HistoryCardEmailRequestRejectedV2: FC<AccountHistoryCardBasePropsI> = ({
  activity,
  isGlenXCampaign,
}) => (
  <AccountHistoryCard createdAt={activity.created_at}>
    <div className="flex flex-col gap-4">
      <HistoryCardActivityType config={ACTIVITY_TYPE_CONFIG} />
      <HistoryCardContactInfo contact={activity.contact} />
    </div>

    <div className="flex flex-col gap-4">
      <HistoryCardCallNotes
        notes={activity.notes}
        isGlenXCampaign={isGlenXCampaign}
      />
    </div>
  </AccountHistoryCard>
);

export default HistoryCardEmailRequestRejectedV2;
